import { AJAX_REQUEST_HEADERS } from '@constants'
import {
  BIND_CARD_API,
  CHECK_PROMOCODE_API,
  CREATE_ORDER_API,
  DELETE_ORDER_DRAFT_API,
  DELETE_ORDER_TEMPLATE_API,
  EDIT_ORDER_API,
  GET_CHECK_PRINT_API,
  GET_DOTS_LAST_ORDER_API,
  GET_FORM_PROPS_API,
  GET_ORDER_DRAFT_API,
  GET_ORDER_TEMPLATE_API,
  GET_SERVICES_API,
} from '@constants/apiEndpoints'
import axios from 'axios'
import qs from 'qs'

class OrderService {
  /**
   * @param data awaiting form object
   * @param data.user user id
   * @param data.promo_code promocode string
   */
  static async checkPromocode(data) {
    const response = await axios.post(CHECK_PROMOCODE_API, data)

    return response
  }

  /**
   * @param buildedOrder awaiting form object
   */
  static async getCheckPrint(buildedOrder, params) {
    const response = await axios.post(GET_CHECK_PRINT_API, buildedOrder, {
      ...AJAX_REQUEST_HEADERS,
      ...params,
    })

    if (!response.data.success)
      throw new Error(response.data.message || 'Ошибка при расчёте заказа')
    return response.data
  }

  /**
   * @param params query params object
   */
  static async getServices(params) {
    const response = await axios.get(GET_SERVICES_API, { params, headers: AJAX_REQUEST_HEADERS })

    if (!response.data.length)
      throw new Error(response.data.message || 'Ошибка при получении данных')
    return response.data
  }

  static async bindCard(cardObject) {
    const response = await axios.post(BIND_CARD_API, cardObject, AJAX_REQUEST_HEADERS)

    if (!response.data.success)
      throw new Error(response.data.message || 'Ошибка. Попробуйте позже.')

    return response
  }

  /**
   * @param buildedOrder awaiting form object
   */
  static async createOrder(buildedOrder) {
    const response = await axios.post(CREATE_ORDER_API, buildedOrder, AJAX_REQUEST_HEADERS)

    if (!response.data.success)
      throw new Error(response.data.message || 'Ошибка при создании заказа')
    return response.data
  }

  /**
   * @param buildedOrder awaiting form object
   */
  static async editOrder(buildedOrder) {
    const response = await axios.post(EDIT_ORDER_API, buildedOrder, AJAX_REQUEST_HEADERS)

    if (!response.data.success)
      throw new Error(response.data.message || 'Ошибка при редактировании')
    return response.data
  }

  /**
   * @param {Object} params - awaiting form object
   * @param {boolean} params.buyout - true/false
   * @param {boolean} params.fromApp - android
   * @param {string} params.id - order id
   * @param {string} params.promocode - promocode
   */
  static async getFormProps(params) {
    const response = await axios.post(GET_FORM_PROPS_API, qs.stringify(params))

    if (!response.data.success)
      throw new Error(response.data.message || 'Ошибка при запросе свойств для формы')
    return response.data
  }

  /**
   * @param {Object} data awaiting object
   * @param {string} data.id template id
   */
  static async deleteOrderDraft(data) {
    const requestData = qs.stringify(data)

    const response = await axios.post(DELETE_ORDER_DRAFT_API, requestData, {
      ...AJAX_REQUEST_HEADERS,
      'Access-Control-Allow-Origin': '*',
    })

    if (!response.data.success)
      throw new Error(response.data.message || 'Ошбика при получении данных')
    return response.data
  }

  /**
   * @param data awaiting form object
   * @param data.tid template id
   */
  static async getDraft(data) {
    const response = await axios.post(GET_ORDER_DRAFT_API, data, {
      ...AJAX_REQUEST_HEADERS,
      'Access-Control-Allow-Origin': '*',
    })

    if (!response.data.success)
      throw new Error(response.data.message || 'Ошбика при получении черновика')
    return response.data
  }

  /**
   * @param {Object} data - object with fields (not qs)
   * @param {string|number} data.orderId - orderId
   * @param {string|number} data.templateType - optional. template type = 0 - only pickup dot, 1 - all data
   */
  static async getOrderTemplate(data) {
    const requestData = qs.stringify({ ...data, templateType: Number(data.templateType) })

    const response = await axios.post(GET_ORDER_TEMPLATE_API, requestData, {
      ...AJAX_REQUEST_HEADERS,
      'Access-Control-Allow-Origin': '*',
    })

    if (!response.data.success)
      throw new Error(response.data.message || 'Ошбика при получении шаблона')
    return response.data
  }

  /**
   * @param {Object} data - object with fields (not qs)
   * @param {string} data.id - template id
   */
  static async deleteOrderTemplate(data) {
    const requestData = qs.stringify(data)

    const response = await axios.post(DELETE_ORDER_TEMPLATE_API, requestData, {
      ...AJAX_REQUEST_HEADERS,
      'Access-Control-Allow-Origin': '*',
    })

    return response.data
  }

  /**
   * @param {number} cityId - awaiting targcity id
   */
  static async getDotsLastOrder(cityId) {
    const response = await axios.get(GET_DOTS_LAST_ORDER_API, { params: { cid: cityId } })

    if (!response.data.success)
      throw new Error(response.data.message || 'Ошбика при получении данных последнего заказа')
    return response.data
  }
}

export default OrderService
